import React from "react";

import Rating from "@/components/Rating";

import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

import {getTextField, getTextAreaField} from "@/utils/functions";

// Campi dell'esercizio di libreria: un solo elenco per pagina e finestra
export const EXERCISE_FIELDS = [
	{key: "name", label: "Titolo", required: true, size: "col-md-6"},
	{key: "exerciseType", label: "Tipologia", required: true, size: "col-md-6"},
	{key: "materials", label: "Materiale", rows: 4, size: "col-md-6"},
	{key: "preparation", label: "Preparazione", rows: 4, size: "col-md-6"},
	{key: "summary", label: "Sommario", rows: 3, size: "col-md-6"},
	{key: "organization", label: "Organizzazione", rows: 3, size: "col-md-6"},
	{
		key: "duration",
		label: "Durata (minuti)",
		type: "number",
		size: "col-md-4",
	},
	{key: "objectives", label: "Obiettivi", size: "col-md-4"},
	{key: "secondaryObjectives", label: "Obiettivi secondari", size: "col-md-4"},
	{key: "description", label: "Descrizione", rows: 6},
	{key: "rules", label: "Regole", rows: 4},
	{key: "variants", label: "Varianti", rows: 4},
	{key: "coachingThemes", label: "Temi per l'allenatore", rows: 4},
	{key: "difficulty", label: "Difficoltà", type: "rating", size: "col-md-6"},
	{key: "tags", label: "Tag", size: "col-md-6"},
	{key: "basicActivities", label: "Attività di base", type: "check"},
	{key: "goalkeepers", label: "Portieri", type: "check"},
];

export default function ExerciseFields({
	fields,
	setFields,
	errors,
	setErrors,
	only,
}) {
	const textField = {values: fields, setValues: setFields, errors, setErrors};
	const visible = only
		? EXERCISE_FIELDS.filter((f) => only.includes(f.key))
		: EXERCISE_FIELDS;

	const renderField = (f) => {
		switch (f.type) {
			case "rating":
				return (
					<>
						<div className="field-label-container">
							<div className="field-label">{f.label}</div>
						</div>
						<Rating
							max={5}
							selectedRating={fields?.[f.key]}
							setSelectedRating={(value) =>
								setFields({...fields, [f.key]: value})
							}
						/>
					</>
				);
			case "check":
				return (
					<FormControlLabel
						control={
							<Checkbox
								size="small"
								checked={fields?.[f.key] || false}
								onChange={(event) =>
									setFields({...fields, [f.key]: event.target.checked})
								}
							/>
						}
						label={f.label}
					/>
				);
			default:
				return f.rows
					? getTextAreaField({
							...textField,
							fieldKey: f.key,
							label: f.label,
							minRows: f.rows,
							maxRows: f.rows,
						})
					: getTextField({
							...textField,
							fieldKey: f.key,
							label: f.label,
							type: f.type,
							required: f.required,
						});
		}
	};

	return (
		<div className="row">
			{visible.map((f) => (
				<div
					key={f.key}
					className={
						"col-12 " +
						(f.type === "check" ? "col-md-6" : f.size || "") +
						" padding-small"
					}
				>
					{renderField(f)}
				</div>
			))}
		</div>
	);
}
